var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.8C14.5,63.8,0.2,49.5,0.2,32S14.5,0.2,32,0.2S63.8,14.5,63.8,32S49.5,63.8,32,63.8z M32,5 C17.1,5,5,17.1,5,32s12.1,27,27,27s27-12.1,27-27S46.9,5,32,5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22185_00000129198164425607392470000007676776218743460540_",
    transform: "translate(-1380.359 -142.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23998_00000140723856344009231340000017045040768979735943_",
    className: "st0",
    d: "M1427.2,190.2l-6.3-11.6l-5-0.2 l2.7,3.2l0.2,4.7l3.8,6.6c0.8,1.3,2.4,1.7,3.7,1c0,0,0,0,0.1,0l0,0C1427.5,193.1,1427.9,191.5,1427.2,190.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23999_00000017498355008735085240000012938002130442855577_",
    className: "st0",
    d: "M1413.1,183.6c-0.6,0.4-1.3,0.6-2,0.6 c-0.3,0-0.6,0-0.9-0.1c1.3,1.9,0.9,4.6-1.1,6c-1.9,1.3-4.6,0.9-6-1.1c-1.3-1.9-0.9-4.6,1.1-6c1.1-0.7,2.4-0.9,3.6-0.6l-3.3-5.2 c-5.1,1.2-8.2,6.3-7,11.4c1.2,5.1,6.3,8.2,11.4,7c5.1-1.2,8.2-6.3,7-11.4c-0.2-1-0.7-2-1.2-2.9 C1414.5,182.2,1413.9,183.1,1413.1,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24000_00000030479612397399868500000011674856033707993778_",
    className: "st0",
    d: "M1409.4,181.5c0.6,0.9,1.8,1.2,2.7,0.6 c0.9-0.6,1.2-1.8,0.6-2.7l-4.4-6.9l3.8-3.7v1.8c0,4.3,2.5,3,2.5,3v-7.8c0.1-1.1-0.6-2.1-1.7-2.2l0,0v-0.1h-5.2 c-1.3,0-2.3,1-2.3,2.3c0,0.2,0,0.3,0,0.5l0.1,0.4l2.8-2.1l1.4,1l-5.4,5.3c-0.7,0.7-0.8,1.7-0.3,2.5L1409.4,181.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7022_00000075156148657049530790000002416733867083698367_",
    className: "st0",
    cx: 1410.4,
    cy: 156.8,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType20);
export default __webpack_public_path__ + "static/media/aioa-icon-type-20.3dd334f5b675adcd9080fc1011ded090.svg";
export { ForwardRef as ReactComponent };